import { defineType } from 'sanity';

export const homePage = defineType({
    name: 'home_page',
    title: 'Home Page',
    type: 'document',
    fields: [
        {
            name: 'domainName',
            title: 'Domain Name',
            type: 'string',
        },
        {
            name: 'beforePromotionComponents',
            title: 'Before Promotion Components',
            type: 'factory',
        },
        {
            name: 'afterPromotionComponents',
            title: 'After Promotion Components',
            type: 'factory',
        },
        {
            name: 'seo',
            title: 'SEO Settings',
            type: 'seo',
            description: 'Search engine optimization settings for better visibility',
        },
    ],
    preview: {
        select: {
            title: 'domainName',
        },
    },
});
